export default __webpack_public_path__ + "static/media/footer_logo.331e86da.png";